"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var player_1 = __importDefault(require("./state/player"));
exports.useComponentStyles = core_1.makeStyles(function (theme) {
    var _a;
    return {
        sliderContainer: {
            flex: '1 1 auto',
        },
        slider: function (props) { return ({
            color: props.playerColors.active,
        }); },
        commonContainer: {
            flex: '0 0 auto',
            '&:hover': {
                cursor: 'pointer',
            },
        },
        icon: function (props) { return ({
            color: props.playerColors.active,
            '&:hover': {
                color: props.playerColors.hover,
            },
        }); },
        volumeIconContainer: {
            position: 'relative',
            '&:hover': {
                cursor: 'pointer',
            },
        },
        volumeControlContainer: (_a = {
                position: 'absolute',
                display: 'none'
            },
            _a[theme.breakpoints.up('sm')] = {
                display: 'flex',
                height: '60px',
            },
            _a.padding = '10px 5px',
            _a),
    };
});
exports.AudioVolumeControl = function (_a) {
    var muteAudio = _a.muteAudio, unmuteAudio = _a.unmuteAudio, _b = _a.classNames, classNames = _b === void 0 ? {} : _b, volume = _a.volume, changeAudioVolume = _a.changeAudioVolume, _c = _a.icons, icons = _c === void 0 ? {} : _c, playerColors = _a.playerColors;
    var classes = exports.useComponentStyles({ playerColors: playerColors });
    var _d = icons.VolumeUpIcon, VolumeUpIcon = _d === void 0 ? icons_1.VolumeUp : _d, _e = icons.VolumeOffIcon, VolumeOffIcon = _e === void 0 ? icons_1.VolumeOff : _e;
    var handleVolumeChange = function (event, value) {
        changeAudioVolume(value);
    };
    var _f = React.useState(false), volumeSlider = _f[0], openVolumeSlider = _f[1];
    var toggleVolumeSlider = function (value) { return function () {
        openVolumeSlider(value);
    }; };
    return (React.createElement(core_1.Grid, { item: true, className: classnames_1.default(classes.commonContainer, classes.volumeIconContainer), onMouseEnter: toggleVolumeSlider(true), onMouseLeave: toggleVolumeSlider(false) },
        volume.status === player_1.default.VOLUME.STATUS.UNMUTE ? (React.createElement(VolumeUpIcon, { fontSize: "large", className: classnames_1.default(classes.icon, classNames.volumeIcon), onClick: muteAudio })) : (React.createElement(VolumeOffIcon, { fontSize: "large", className: classnames_1.default(classes.icon, classNames.volumeIcon), onClick: unmuteAudio })),
        volumeSlider && (React.createElement(core_1.Paper, { className: classnames_1.default(classes.volumeControlContainer) },
            React.createElement(core_1.Slider, { orientation: "vertical", "aria-labelledby": "volume-control", value: volume.value, defaultValue: player_1.default.VOLUME.DEFAULT_VALUE, onChange: handleVolumeChange, className: classnames_1.default(classes.slider, classNames.volumeSlider) })))));
};
exports.default = React.memo(exports.AudioVolumeControl);
//# sourceMappingURL=AudioVolumeControl.js.map